import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {getComponents} from "../utilities";
import Slider from "../../components/slider";
import {IS_MOBILE} from "../../constants/environment";
import BodyControl from "../../components/body";
import {convertPipeToBrTag, convertKataToRome} from "../../utils";
import {getCookie, setCookie, removeCookie, isEqualId, formatId} from "../utilities";

/**
 *  GradeAndSpec
 */
class GradeAndSpec extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    vehicleType: PropTypes.string,
    vehicleTabName: PropTypes.string,
    models: PropTypes.arrayOf(PropTypes.shape({
      modelName: PropTypes.string,
      bodyTypes: PropTypes.arrayOf(PropTypes.shape({
        default: PropTypes.bool,
        carId: PropTypes.string,
        bodyTypeModel: PropTypes.string,
        bodyTypeTabName: PropTypes.string,
        generations: PropTypes.arrayOf(PropTypes.shape({
          carTypeCode: PropTypes.string,
          gradeAndSpecData: PropTypes.array,
        })),
      })),
    })),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    vehicleType: null,
    vehicleTabName: null,
    models: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    this.currentBodyTypeId = this.getDefaultBodyTypeId();
    this.currentEngineName = this.getDefaultEngineName(this.currentBodyTypeId);
    this.currentVehicleType = this.getDefaultVehicleType(this.currentBodyTypeId, this.currentEngineName);
    this.currentGradeId = this.getDefaultGradeId(this.currentBodyTypeId, this.currentEngineName, this.currentVehicleType);
    //
    this.state = {
      bodyTypeId: this.currentBodyTypeId,
      engineName: this.currentEngineName,
      vehicleType: this.currentVehicleType,
      gradeId: this.currentGradeId,
      isMounted: false,
      //fuelNavScrolled: false,
      navItemHeight: 'auto',
    };
    //
    this.gradesInfo = this.getGradsInfo();
    this.navItems = [];
    this.intervalId = null;
  }

  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      models,
    } = this.props;

    this.navItems = [];

    // ボディタイプナビゲーション
    const renderBodyTypeNav = () => {
      const bodyTypeNavInfo = this.getBodyTypeNavInfo();
      if (2 <= bodyTypeNavInfo.length) {
        return (
          <ul className="GradeAndSpec__body-type-nav">
            {bodyTypeNavInfo.map((info, index) => {
              return (
                <li key={index}>
                  <a
                    className={'GradeAndSpec__body-type-nav__link' + ((isEqualId(this.state.bodyTypeId, info.id) ? ' current': ''))}
                    // className={'GradeAndSpec__body-type-nav__link' + ((this.state.bodyTypeId === info.id ? ' current': ''))}
                    href="javascript:void(0);"
                    onClick={(e) => {
                      e.preventDefault();
                      this.changeBodyType(info.id);

                      // ブロックのCookieに保存
                      setCookie('mj_gsbt', formatId(info.id));
                      removeCookie('mj_gsgr');

                    }}
                  >
                    {info.bodyTypeTabName}
                  </a>
                </li>
              )
            })}
          </ul>
        )
      } else {
        return null;
      }
    };

    // エンジンナビゲーション
    const renderEngineNav = () => {
      const engineNavInfo = this.getEngineNavInfo(this.state.bodyTypeId);
      const gradeInfo = this.getGradeInfo(this.state.bodyTypeId);
      return (
        <div className="GradeAndSpec__engine-nav" ref="engineNav">
          <div className="GradeAndSpec__engine-nav__container">
            <ul className="GradeAndSpec__engine-nav__list" ref="engineNavList">
              {engineNavInfo.map((info, index) => {
                return (
                  <li key={index}>
                    <a
                      className={'GradeAndSpec__engine-nav__link' + ((this.state.engineName === info ? ' current': ''))}
                      href="javascript:void(0);"
                      onClick={(e) => {
                        e.preventDefault();
                        // 絞り込み条件設定
                        this.setEngineNameRefine(info);

                        // ブロックのCookieに保存
                        setCookie('mj_gsbt', formatId(this.currentBodyTypeId));
                        setCookie('mj_gsgr', formatId(this.currentGradeId));

                      }}
                    >
                      {this.getFuelTabName(gradeInfo, info)}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      )
    };

    // 車両タイプナビゲーション
    const renderVehicleTypeNav = () => {
      const vehicleType = this.getVehicleTypeInfo(this.state.bodyTypeId, this.state.engineName);
      if (2 <= vehicleType.length) {
        return (
          <div className="GradeAndSpec__vehicle-type">
            <ul className="GradeAndSpec__vehicle-type__list">
              {vehicleType.map((info, index) => {
                return (
                  <li key={index}>
                    <a
                      className={'GradeAndSpec__vehicle-type__link' + ((this.state.vehicleType === info ? ' current': ''))}
                      href="javascript:void(0);"
                      onClick={(e) => {
                        e.preventDefault();
                        // 絞り込み条件設定
                        this.setVehicleTypeRefine(info);

                        // ブロックのCookieに保存
                        //setCookie('mj_gsbt', formatId(this.currentBodyTypeId));
                        //setCookie('mj_gsgr', formatId(this.currentGradeId));

                      }}
                    >
                      {info}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      } else {
        return null;
      }
    };

    // グレードナビゲーション
    const renderGradeNav = () => {
      if (this.state.isMounted === true) {
        const gradeNavInfo = this.getGradeNavInfo(this.state.bodyTypeId);
        if (((IS_MOBILE === true) ? 2: 7) <= gradeNavInfo.length) {
          return (
            <div className="GradeAndSpec__grade-nav">
              <ul className="GradeAndSpec__grade-nav__list">
                <Slider settings={{
                  autoplay: false,
                  autoplaySpeed: 3000,
                  speed: 1000,
                  ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                  fade: false,
                  infinite: true,
                  slidesToShow: 6,
                  slidesToScroll: 6,
                  swipe: true,
                  draggable: false,
                  arrows: true,
                  dots: false,
                  adaptiveHeight: false,
                  centerMode: false,
                  centerPadding: 0,
                  //waitForAnimate: false,
                  lazyLoad: 'progressive',
                  responsive: [
                    {
                      breakpoint: 767,
                      settings: {
                        speed: 500,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: false,
                        dots: true,
                        centerMode: false,
                        //centerPadding: '10%',
                      },
                    },
                  ],
                }}>
                  {gradeNavInfo.map((info, index) => {
                    return (
                      renderGradeNavItem(info, index)
                    )
                  })}
                </Slider>
              </ul>
            </div>
          )
        } else {
          return (
            <div className="GradeAndSpec__grade-nav">
              <ul className="GradeAndSpec__grade-nav__list fixed">
                {gradeNavInfo.map((info, index) => {
                  return (
                    renderGradeNavItem(info, index)
                  )
                })}
              </ul>
            </div>
          )
        }
      } else {
        return null;
      }
    };

    // グレードナビゲーションアイテム
    const renderGradeNavItem = (info, index) => {
      const getGradeName = () => {
        if (info.gradeName && info.gradeName !== '') {
          return info.gradeName;
        } else if (info.gradeId && info.gradeId !== '') {
          return info.gradeId
        } else {
          return '';
        }
      };

      // 100th Anniversary Special Edition > 100周年特別記念車
      const convert100th = (text) => {
        if (text && text !== '') {
          text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
          text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
          text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
          text = text.replace('RF 35th SV', '35周年記念車');
          text = text.replace('35th SV', '35周年記念車');
          text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
          text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
          text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
          text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
          text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
          text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
          text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
          text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
          text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
          text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
          text = text.replace('15 SPORT Plus', '15 SPORT＋');
          text = text.replace('XD SPORT Plus', 'XD SPORT＋');
          return text;
        } else {
          return text;
        }
      };

      //
      const ref = React.createRef();
      // const ref = 'item' + index;
      this.navItems.push(ref);
      //
      if (info.specialCar === true) {
        return (
          <li className="GradeAndSpec__grade-nav__list-item" key={index}>
            {/*<a className={'GradeAndSpec__grade-nav__link' + ((this.state.gradeId === info.id ? ' current': ''))}*/}
            <a className={'GradeAndSpec__grade-nav__link' + ((isEqualId(this.state.gradeId, info.id) ? ' current': ''))}
               //href={(info.gradeSpecUrl) ? info.gradeSpecUrl: 'javascript:void(0);'}
               href="javascript:void(0);"
               onClick={(e) => {
                 e.preventDefault();
                 this.changeGrade(info.id);

                 // ブロックのCookieに保存
                 setCookie('mj_gsbt', formatId(this.currentBodyTypeId));
                 setCookie('mj_gsgr', formatId(info.id));

               }}
            >
              <div className="GradeAndSpec__grade-nav__text-wrapper" style={{height: this.state.navItemHeight}}>
                <div ref={ref}>
                  <div className="GradeAndSpec__grade-nav__vehicle-type">
                    <span>{(info.specialCarTabName && info.specialCarTabName !== '') ? info.specialCarTabName: '特別仕様車'}</span>
                  </div>
                  <span className="GradeAndSpec__grade-nav__grade">
                    <span dangerouslySetInnerHTML={{__html: (info.gradeId && info.gradeId !== '') ? convert100th(info.gradeId) : ''}}/>
                    {/*<span dangerouslySetInnerHTML={{__html: (info.gradeId && info.gradeId !== '') ? info.gradeId : ''}}/>*/}
                  </span>
                  <span className="GradeAndSpec__grade-nav__engine">{info.drive}<br/>{info.transmission}</span>
                  {/*<span className="GradeAndSpec__grade-nav__engine">{info.drive + ' ' + info.transmission}</span>*/}
                </div>
              </div>
              <div className="GradeAndSpec__grade-nav__image-wrapper">
                <div className="GradeAndSpec__grade-nav__image-wrapper2">
                  {(this.state.isMounted === true) ?
                    // <img className="GradeAndSpec__grade-nav__image a" src="https://www.mazda.co.jp/globalassets/assets/cars/mazda2/mazda2/dj2/15s-proactive-smart-edition/common/15s-proactive-smart-edition_default_s.png"/>
                    <img className="GradeAndSpec__grade-nav__image" src={this.getGradeImageDirectory(this.state.bodyTypeId, info.id) + this.getGradeImageName(this.props.models[0].vehicleType, this.state.bodyTypeId, info.id, 's')}/>
                    : null}
                </div>
              </div>
            </a>
          </li>
        )
      } else if (info.welfareCar === true) {
        return (
          <li className="GradeAndSpec__grade-nav__list-item" key={index}>
            {/*<a className={'GradeAndSpec__grade-nav__link' + ((this.state.gradeId === info.id ? ' current': ''))}*/}
            <a className={'GradeAndSpec__grade-nav__link' + ((isEqualId(this.state.gradeId, info.id) ? ' current': ''))}
               href={(info.gradeSpecUrl) ? info.gradeSpecUrl: 'javascript:void(0);'}
            >
              <div className="GradeAndSpec__grade-nav__text-wrapper" style={{height: this.state.navItemHeight}}>
                <div ref={ref}>
                  <div className="GradeAndSpec__grade-nav__vehicle-type">
                    <span>{(info.welfareCarTabName && info.welfareCarTabName !== '') ? info.welfareCarTabName: '福祉車両'}</span>
                  </div>
                  <span className="GradeAndSpec__grade-nav__grade">
                    <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(convert100th(getGradeName()))}}/>
                    {/*<span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getGradeName())}}/>*/}
                  </span>
                  <span className="GradeAndSpec__grade-nav__engine">{info.drive}<br/>{info.transmission}</span>
                  {/*<span className="GradeAndSpec__grade-nav__engine">{info.drive + ' ' + info.transmission}</span>*/}
                </div>
              </div>
              <div className="GradeAndSpec__grade-nav__image-wrapper">
                <div className="GradeAndSpec__grade-nav__image-wrapper2">
                  {(this.state.isMounted === true) ?
                    // <img className="GradeAndSpec__grade-nav__image a" src="https://www.mazda.co.jp/globalassets/assets/cars/mazda2/mazda2/dj2/15s-smart-edition/common/15s-smart-edition_default_s.png" />
                    <img className="GradeAndSpec__grade-nav__image" src={this.getGradeImageDirectory(this.state.bodyTypeId, info.id) + this.getGradeImageName(this.props.models[0].vehicleType, this.state.bodyTypeId, info.id, 's')}/>
                    : null}
                </div>
              </div>
            </a>
          </li>
        )
      } else {
        return (
          <li className="GradeAndSpec__grade-nav__list-item" key={index}>
            {/*<a className={'GradeAndSpec__grade-nav__link' + ((this.state.gradeId === info.id ? ' current': ''))}*/}
            <a className={'GradeAndSpec__grade-nav__link' + ((isEqualId(this.state.gradeId, info.id) ? ' current': ''))}
               href="javascript:void(0);"
               onClick={(e) => {
                 e.preventDefault();
                 this.changeGrade(info.id);

                 // ブロックのCookieに保存
                 setCookie('mj_gsbt', formatId(this.currentBodyTypeId));
                 setCookie('mj_gsgr', formatId(info.id));

               }}
            >
              <div className="GradeAndSpec__grade-nav__text-wrapper" style={{height: this.state.navItemHeight}}>
                <div ref={ref}>
                  <div className="GradeAndSpec__grade-nav__vehicle-type"/>
                  <span className="GradeAndSpec__grade-nav__grade">
                    <span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(convert100th(getGradeName()))}}/>
                    {/*<span dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getGradeName())}}/>*/}
                  </span>
                  <span className="GradeAndSpec__grade-nav__engine">{info.drive}<br/>{info.transmission}</span>
                  {/*<span className="GradeAndSpec__grade-nav__engine">{info.drive + ' ' + info.transmission}</span>*/}
                </div>
              </div>
              <div className="GradeAndSpec__grade-nav__image-wrapper">
                <div className="GradeAndSpec__grade-nav__image-wrapper2">
                  {(this.state.isMounted === true) ?
                    // <img className="GradeAndSpec__grade-nav__image k" src="https://www.mazda.co.jp/globalassets/assets/cars/mazda2/mazda2/dj2/15s-smart-edition/common/15s-smart-edition_default_s.png" />
                    <img className="GradeAndSpec__grade-nav__image" src={this.getGradeImageDirectory(this.state.bodyTypeId, info.id) + this.getGradeImageName(this.props.models[0].vehicleType, this.state.bodyTypeId, info.id, 's')}/>
                    : null}
                </div>
              </div>
            </a>
          </li>
        )
      }
    };

    // グレード
    const renderGrade = () => {
      if (!this.state.isMounted) return;
      return (
        <div>
          {this.gradesInfo.map((gradeInfo, index)=> {
            if (gradeInfo.props.welfareCar === true) {
              return null;
            } else {
              if (this.state.isMounted === true) {
                // const isCurrent = (this.currentBodyTypeId === gradeInfo.bodyTypeId && this.currentGradeId === gradeInfo.props.gradeId) ? true : false;
                const isCurrent = (isEqualId(this.currentBodyTypeId, gradeInfo.bodyTypeId) && isEqualId(this.currentGradeId, gradeInfo.props.gradeId)) ? true : false;

                // GTMイベントで利用するボディータイプ
                const getBodyTypeTabName = (bodyTypeId)=> {
                  let i, max;
                  for (i = 0, max = this.props.models.length; i < max; i = i + 1) {
                    const model = this.props.models[i];
                    let j, max2;
                    for (j = 0, max2 = model.bodyTypes.length; j < max2; j = j + 1) {
                      const bodyType = model.bodyTypes[j];
                      if (isEqualId(bodyTypeId, bodyType.carId)) {
                        return bodyType.bodyTypeTabName
                      }
                    }
                  }
                  return null;
                };

                // return (
                //   <div className="GradeAndSpec__grade" style={(isCurrent) ? {display: 'block'} : {display: 'none'}} key={index}>
                //     {getComponents([gradeInfo], {
                //       modelName: this.props.models[0].modelName,
                //       gradeImageSrc: this.getGradeImageDirectory(gradeInfo.bodyTypeId, gradeInfo.props.gradeId) + this.getGradeImageName(this.props.models[0].vehicleType, gradeInfo.bodyTypeId, gradeInfo.props.gradeId, 'l'),
                //       bodyTypeModel: gradeInfo.bodyTypeId,
                //       carTypeCode: this.getCarTypeCode(gradeInfo.bodyTypeId),
                //       isCurrent: isCurrent,
                //       bodyTypeTabName: getBodyTypeTabName(gradeInfo.bodyTypeId)
                //     })}
                //   </div>
                // );

                if (isCurrent) {
                  return (
                    <div className="GradeAndSpec__grade" key={index}>
                      {getComponents([gradeInfo], {
                        modelName: this.props.models[0].modelName,
                        gradeImageSrc: this.getGradeImageDirectory(gradeInfo.bodyTypeId, gradeInfo.props.gradeId) + this.getGradeImageName(this.props.models[0].vehicleType, gradeInfo.bodyTypeId, gradeInfo.props.gradeId, 'l'),
                        bodyTypeModel: gradeInfo.bodyTypeId,
                        carTypeCode: this.getCarTypeCode(gradeInfo.bodyTypeId),
                        isCurrent: isCurrent,
                        bodyTypeTabName: getBodyTypeTabName(gradeInfo.bodyTypeId)
                      })}
                    </div>
                  );
                }

              } else {
                return null;
              }
            }
          })}
        </div>
      )
    };

    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className="GradeAndSpec">
          {renderBodyTypeNav()}
          <div className="GradeAndSpec__fade-in-container open" ref="engineNav">
            {renderEngineNav()}
            <div className="GradeAndSpec__fade-in-container open" ref="vehicleTypeNav">
              {renderVehicleTypeNav()}
              <div className="GradeAndSpec__fade-in-container open" ref="gradeNav">
                {renderGradeNav()}
                <div className="GradeAndSpec__fade-in-container open" ref="grade">
                  {renderGrade()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }

  componentDidMount() {

    this.setState({
      isMounted: true,
    });

    // URLパラメータでダイレクト遷移
    this.setCurrentByParams();

    //
    window.addEventListener('resize', this.handleResize);
    setTimeout(()=> {
      this.handleResize();
    }, 100);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(()=> {
      this.handleResize();
    }, 200)
  };

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
    //
    window.removeEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
  }

  componentDidUpdate(prevProps, prevState) {
    // if (prevState.isMounted !== this.state.isMounted) {
    //   const carId = BodyControl.getUrlParameter('car_id');
    //   const gradeId = BodyControl.getUrlParameter('grade_id');
    //   if (carId && carId !== '') {
    //     this.currentBodyTypeId = carId;
    //     this.currentengineName = this.getDefaultengineName(this.currentBodyTypeId);
    //     this.currentVehicleType = this.getDefaultVehicleType(this.currentBodyTypeId, this.currentengineName);
    //     if (gradeId && gradeId !== '') {
    //       this.currentGradeId = gradeId;
    //     } else {
    //       this.currentGradeId = this.getDefaultGradeId(this.currentBodyTypeId, this.currentengineName, this.currentVehicleType);
    //     }
    //   }
    //   console.log(carId);
    //   console.log(this.currentGradeId);
    // }
  }

  // リサイズ
  handleResize = () => {
    let maxHeight = 0;
    let i, max;
    for (i = 0, max = this.navItems.length; i < max; i = i + 1) {
      const navItem = this.navItems[i].current || null;
      // const navItem = this.refs[this.navItems[i]] || null;
      if (navItem) {
        if (maxHeight < navItem.clientHeight) {
          maxHeight = navItem.clientHeight;
        }
      }
    }
    if (!maxHeight) {
      maxHeight = "auto";
    }
    this.setState({
      navItemHeight: maxHeight
    })
  };

  getEngineFuel = (gradeInfo) => {
    if (gradeInfo.welfareCar === true) {
      if (gradeInfo.welfareCarEngines && gradeInfo.welfareCarEngines !== '') {
        return gradeInfo.welfareCarEngines.split(',')[0];
      } else {
        return null;
      }
    } else {
      if (gradeInfo.engine && gradeInfo.engine.fuel) {
        return gradeInfo.engine.fuel;
      } else {
        return null;
      }
    }
  };

  // ボディタイプ情報を燃料とタイプで絞り込む
  narrowBodyTypeInfo = (gradeInfo, engineName = null, vehicleType = null) => {
    //
    let i, max;
    // 燃料で絞り込み
    if (engineName && engineName !== '') {
      let arr = [];
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].welfareCar === true) {
          if (gradeInfo[i].welfareCarEngines && gradeInfo[i].welfareCarEngines !== '') {
            let arr2 = gradeInfo[i].welfareCarEngines.split(',');
            let flg = false;
            let j, max2;
            for (j = 0, max2 = arr2.length; j < max2; j = j + 1) {
              if (arr2[j] === engineName) {
                flg = true;
              }
            }
            if (flg) {
              arr.push(gradeInfo[i]);
            }
          }
        } else {
          if (this.getEngineFuel(gradeInfo[i]) === engineName) {
            arr.push(gradeInfo[i]);
          }
        }
      }
      gradeInfo = arr;
    } else if (this.defaultEngineName && this.defaultEngineName !== '') {
      let arr = [];
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (this.getEngineFuel(gradeInfo[i]) === this.defaultEngineName) {
          arr.push(gradeInfo[i]);
        }
      }
      gradeInfo = arr;
    }
    // タイプで絞り込み
    if (vehicleType && vehicleType !== '' && vehicleType !== 'ALL') {
      let arr = [];
      for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
        if (gradeInfo[i].specialCar === true && gradeInfo[i].specialCarTabName === vehicleType) {
          arr.push(gradeInfo[i]);
        } else if (gradeInfo[i].welfareCar === true && gradeInfo[i].welfareCarTabName === vehicleType) {
          arr.push(gradeInfo[i]);
        }
      }
      gradeInfo = arr;
    }
    return gradeInfo;
  };

  /* ----- デフォルト取得 ----- */

  // デフォルトボディタイプ取得
  getDefaultBodyTypeId = () => {
    let i, max;
    for (i = 0, max = this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
      const bodyType = this.props.models[0].bodyTypes[i];
      if (bodyType.default === true) {
        return bodyType.carId;
      }
    }
    return this.props.models[0].bodyTypes[0].carId;
  };

  // グレード情報
  getGradeInfo = (bodyTypeId) => {
    let info = [];
    let i, max;
    for (i = 0, max = this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
      const bodyType = this.props.models[0].bodyTypes[i];
      // if (bodyType.carId === bodyTypeId) {
      if (isEqualId(bodyType.carId, bodyTypeId)) {
        let j, max2;
        for (j = 0, max2 = bodyType.generations[0].gradeAndSpecData.length; j < max2; j = j + 1) {
          const gradeAndSpecData = bodyType.generations[0].gradeAndSpecData[j];
          info.push(gradeAndSpecData.props);
        }
        return info;
      }
    }
    for (i = 0, max = this.props.models[0].bodyTypes[0].generations[0].gradeAndSpecData.length; i < max; i = i + 1) {
      const gradeAndSpecData = this.props.models[0].bodyTypes[0].generations[0].gradeAndSpecData[i];
      info.push(gradeAndSpecData.props);
    }
    return info;
  };

  // 全てのグレード情報
  getGradsInfo = ()=> {
    let info = [];
    let i, max;
    for (i = 0, max = this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
      const bodyType = this.props.models[0].bodyTypes[i];
      const bodyTypeId = bodyType.carId;
      let j, max2;
      for (j = 0, max2 = bodyType.generations[0].gradeAndSpecData.length; j < max2; j = j + 1) {
        const gradeAndSpecData = bodyType.generations[0].gradeAndSpecData[j];
        info.push({
          name: gradeAndSpecData.name,
          props: gradeAndSpecData.props,
          bodyTypeId: bodyTypeId,
        });
      }
    }
    return info;
  };

  // デフォルト燃料取得
  getDefaultEngineName = (bodyTypeId) => {
    const gradeInfo = this.getGradeInfo(bodyTypeId);
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      if (gradeInfo[i].default === true) {
        return this.getEngineFuel(gradeInfo[i]);
      }
    }
    return this.getEngineFuel(gradeInfo[0]);
  };

  // デフォルト車両タイプ
  getDefaultVehicleType = (bodyTypeId, engineName) => {
    return 'ALL';
  };

  // デフォルトグレード取得
  getDefaultGradeId = (bodyTypeId, engineName = null, vehicleType = null) => {
    //console.log('getDefaultGradeId : ' + bodyTypeId + '@' + engineName + '@' + vehicleType);
    let gradeInfo = this.getGradeInfo(bodyTypeId);
    //  燃料とタイプで絞り込む
    gradeInfo = this.narrowBodyTypeInfo(gradeInfo, engineName, vehicleType);
    //
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      if (gradeInfo[i].default === true) {
        return gradeInfo[i].gradeId;
      }
    }
    return gradeInfo[0].gradeId;
  };

  /* ----- 情報取得 ----- */

  // ボディタイプナビゲーション情報取得
  getBodyTypeNavInfo = () => {
    let info = [];
    let i, max;
    for (i = 0, max = this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
      const bodyType = this.props.models[0].bodyTypes[i];
      info.push({
        id: bodyType.carId,
        bodyTypeTabName: bodyType.bodyTypeTabName,
      })
    }
    return info;
  };

  // 燃料リスト取得
  getEngineNavInfo = (bodyTypeId) => {
    const gradeInfo = this.getGradeInfo(bodyTypeId);
    let info = [];
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      // 福祉車両はwelfareCarEnginesで判別
      if (gradeInfo[i].welfareCar === true) {
        if (gradeInfo[i].welfareCarEngines && gradeInfo[i].welfareCarEngines !== '') {
          info = info.concat(gradeInfo[i].welfareCarEngines.split(','));
        }
      } else {
        if (gradeInfo[i].engine && gradeInfo[i].engine.fuel) {
          info.push(gradeInfo[i].engine.fuel);
        }
      }
    }
    return info.filter((x, i, self) => self.indexOf(x) === i);
  };

  // 燃料タブ取得
  getFuelTabName = (gradeInfo, engineName) => {
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      if (gradeInfo[i].welfareCar !== true) {
        if (gradeInfo[i].engine && gradeInfo[i].engine.fuel && gradeInfo[i].engine.fuel === engineName) {
          return gradeInfo[i].fuelTabName;
        }
      }
    }
    return engineName;
  };

  // 車両タイプ情報取得
  getVehicleTypeInfo = (bodyTypeId, engineName) => {
    const gradeInfo = this.getGradeInfo(bodyTypeId);
    let flg = false;
    let info = [null, null, null];
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      if (gradeInfo[i].specialCar === true) {
        if (gradeInfo[i].engine && gradeInfo[i].engine.fuel && gradeInfo[i].engine.fuel === engineName) {
          info[1] = gradeInfo[i].specialCarTabName || '特別仕様車';
        }
      } else if (gradeInfo[i].welfareCar === true) {
        if (gradeInfo[i].welfareCarEngines && gradeInfo[i].welfareCarEngines !== '') {
          gradeInfo[i].welfareCarEngines.split(',').map((engine, index)=> {
            if (engine === engineName) {
              info[2] = gradeInfo[i].welfareCarTabName || '福祉車両';
            }
          })
        }
      } else {
        if (gradeInfo[i].engine && gradeInfo[i].engine.fuel && gradeInfo[i].engine.fuel === engineName) {
          flg = true;
        }
      }
    }
    if (flg && (info[1] !== null || info[2] !== null)) {
      info[0] = 'ALL';
    }
    let info2 = [];
    for (i = 0, max = info.length; i < max; i = i + 1) {
      if (info[i] !== null) info2.push(info[i]);
    }
    return info2;
  };

  // グレードナビゲーション情報取得
  getGradeNavInfo = (bodyTypeId) => {
    let gradeInfo = this.getGradeInfo(bodyTypeId);
    //  燃料とタイプで絞り込む
    gradeInfo = this.narrowBodyTypeInfo(gradeInfo, this.currentEngineName, this.currentVehicleType);
    //
    let info = [];
    let i, max;
    for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
      let drives = '';
      let transmissions = '';
      if (gradeInfo[i].variants) {
        let k, max3;
        for (k = 0, max3 = gradeInfo[i].variants.length; k < max3; k = k + 1) {
          const variant = gradeInfo[i].variants[k];
          if (drives === '') {
            drives = variant.drive;
          } else {
            drives = drives + '/' + variant.drive;
          }
          if (transmissions === '') {
            transmissions = variant.transmission;
          } else {
            transmissions = transmissions + '/' + variant.transmission;
          }
        }
      }
      info.push({
        id: gradeInfo[i].gradeId,
        gradeId: gradeInfo[i].gradeId,
        gradeName: gradeInfo[i].gradeName,
        //engineName: this.getEngineFuel(gradeInfo[i]),
        specialCar: gradeInfo[i].specialCar,
        specialCarTabName: gradeInfo[i].specialCarTabName,
        welfareCar: gradeInfo[i].welfareCar,
        welfareCarTabName: gradeInfo[i].welfareCarTabName,
        gradeSpecUrl: gradeInfo[i].gradeSpecUrl,
        drive: drives.split('/').filter((x, i, self) => self.indexOf(x) === i).join('/'),
        transmission: transmissions.split('/').filter((x, i, self) => self.indexOf(x) === i).join('/'),
      })
    }
    return info;
  };

  // CarTypeCode取得
  getCarTypeCode = (bodyTypeId) => {
    let i, max;
    for (i = 0, max = this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
      const bodyType = this.props.models[0].bodyTypes[i];
      //if (bodyType.carId === bodyTypeId) {
      if (isEqualId(bodyType.carId, bodyTypeId)) {
        return bodyType.generations[0].carTypeCode;
      }
    }
    return '';
  };

  // カレントグレード取得
  getCurrentGrade = (bodyTypeId, gradeId) => {
    let i, max;
    for (i = 0, max = this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
      const bodyType = this.props.models[0].bodyTypes[i];
      //if (bodyType.carId === bodyTypeId) {
      if (isEqualId(bodyType.carId, bodyTypeId)) {
        let j, max2;
        for (j = 0, max2 = bodyType.generations[0].gradeAndSpecData.length; j < max2; j = j + 1) {
          const gradeAndSpecData = bodyType.generations[0].gradeAndSpecData[j];
          //if (gradeAndSpecData.props.gradeId === gradeId) {
          if (isEqualId(gradeAndSpecData.props.gradeId, gradeId)) {
            return gradeAndSpecData;
          }
        }
      }
    }
    return null;
  };

  // グレード画像ディレクトリ取得
  getGradeImageDirectory = (bodyTypeId, gradeId) => {
    //let str = '/globalassets/assets/cars/';
    let str = '';
    if (0 <= String(location.hostname).indexOf('localhost')) {
      str = '/assets-dev/assets/cars/';
    } else {
      str = '/globalassets/assets/cars/';
    }
    str = str + this.props.models[0].modelName + '/';
    //
    let i, max;
    for (i = 0, max = this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
      const bodyType = this.props.models[0].bodyTypes[i];
      //if (bodyType.carId === bodyTypeId) {
      if (isEqualId(bodyType.carId, bodyTypeId)) {
        str = str + bodyType.carId + '/';
        str = str + bodyType.generations[0].carTypeCode + '/';
        //
        let j, max2;
        for (j = 0, max2 = bodyType.generations[0].gradeAndSpecData.length; j < max2; j = j + 1) {
          const gradeAndSpecData = bodyType.generations[0].gradeAndSpecData[j];
          // if (gradeAndSpecData.props.gradeId === gradeId) {
          if (isEqualId(gradeAndSpecData.props.gradeId, gradeId)) {
            str = str + convertKataToRome(gradeAndSpecData.props.gradeId) + '/common/';
            str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
            return str;
          }
        }
      }
    }
    return '';
  };

  // グレード画像名取得
  getGradeImageName = (vehicleType, bodyTypeId, gradeId, size) => {
    let str = '';
    if (vehicleType === 'Commercial Car') {
      str = str + 'commercial_';
    } else if (this.getCurrentGrade(bodyTypeId, gradeId).props.welfareCar === true) {
      str = str + 'welfare_';
    }
    str = str + convertKataToRome(gradeId) + '_default_' + size + '.png';
    str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
    return str;
  };

  /* ----- 選択・変更 ----- */

  // ボディタイプ変更
  changeBodyType = (bodyTypeId) => {
    //console.log('changeBodyType : ' + bodyTypeId);
    this.currentBodyTypeId = bodyTypeId;
    this.currentEngineName = this.getDefaultEngineName(this.currentBodyTypeId);
    this.currentVehicleType = this.getDefaultVehicleType(this.currentBodyTypeId, this.currentEngineName);
    this.currentGradeId = this.getDefaultGradeId(this.currentBodyTypeId, this.currentEngineName, this.currentVehicleType);
    this.setState({
      bodyTypeId: this.currentBodyTypeId,
      engineName: this.currentEngineName,
      vehicleType: this.currentVehicleType,
      gradeId: this.currentGradeId,
    });
    // フェードインアニメーション
    this.refs.engineNav.classList.remove('open');
    setTimeout(() => {
      this.refs.engineNav.classList.add('open');
    }, 100);
  };

  // 絞り込み条件設定
  setEngineNameRefine = (engineName) => {
    //console.log('setEngineNameRefine : ' + engineName);
    this.currentEngineName = engineName;
    this.currentVehicleType = this.getDefaultVehicleType(this.currentBodyTypeId, this.currentEngineName);
    this.currentGradeId = this.getDefaultGradeId(this.currentBodyTypeId, this.currentEngineName, this.currentVehicleType);
    this.setState({
      engineName: this.currentEngineName,
      vehicleType: this.currentVehicleType,
      gradeId: this.currentGradeId,
    });
    // フェードインアニメーション
    this.refs.vehicleTypeNav.classList.remove('open');
    setTimeout(() => {
      this.refs.vehicleTypeNav.classList.add('open');
    }, 100);
  };

  // 絞り込み条件設定
  setVehicleTypeRefine = (vehicleType) => {
    //console.log('setVehicleTypeRefine : ' + vehicleType);
    this.currentVehicleType = vehicleType;
    this.currentGradeId = this.getDefaultGradeId(this.currentBodyTypeId, this.currentEngineName, this.currentVehicleType);
    this.setState({
      vehicleType: this.currentVehicleType,
      gradeId: this.currentGradeId,
    });
    // フェードインアニメーション
    this.refs.gradeNav.classList.remove('open');
    setTimeout(() => {
      this.refs.gradeNav.classList.add('open');
    }, 100);
  };

  // グレード変更
  changeGrade = (gradeId) => {
    // if (this.currentGradeId === gradeId) return;
    if (isEqualId(this.currentGradeId, gradeId)) return;
    //
    this.currentGradeId = gradeId;
    this.setState({
      gradeId: this.currentGradeId,
    });
    // フェードインアニメーション
    this.refs.grade.classList.remove('open');
    setTimeout(() => {
      this.refs.grade.classList.add('open');
    }, 100);
  };

  // URLパラメータでダイレクト遷移
  setCurrentByParams = () => {

    const setCurrent = (bodyTypeId, gradeId) => {

      // BodyTypeが存在するか否か
      const getIsExistBodyType = (bodyTypeId) => {
        if (!bodyTypeId || bodyTypeId === '') return false;
        //
        let i, max;
        for (i = 0, max = this.props.models[0].bodyTypes.length; i < max; i = i + 1) {
          const bodyType = this.props.models[0].bodyTypes[i];
          //if (bodyType.carId === bodyTypeId) {
          if (isEqualId(bodyType.carId, bodyTypeId)) {
            return true;
          }
        }
        return false;
      };

      // Gradeが存在するか否か
      const getIsExistGrade = (bodyTypeId, gradeId) => {
        if (!gradeId || gradeId === '') return false;
        //
        const gradeInfo = this.getGradeInfo(bodyTypeId);
        let i, max;
        for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
          //if (gradeInfo[i].gradeId === gradeId) {
          if (isEqualId(gradeInfo[i].gradeId, gradeId)) {
            return true;
          }
        }
        return false;
      };

      const isExistBodyType = getIsExistBodyType(bodyTypeId);
      let isExistGrade = false;
      if (isExistBodyType) {
        isExistGrade = getIsExistGrade(bodyTypeId, gradeId);
      }

      if (isExistBodyType && isExistGrade) {
        this.currentBodyTypeId = bodyTypeId;
        //
        const gradeInfo = this.getGradeInfo(bodyTypeId);
        let i, max;
        for (i = 0, max = gradeInfo.length; i < max; i = i + 1) {
          //if (gradeInfo[i].gradeId === gradeId) {
          if (isEqualId(gradeInfo[i].gradeId, gradeId)) {
            this.currentEngineName = this.getEngineFuel(gradeInfo[i]);
          }
        }
        //
        this.currentVehicleType = this.getDefaultVehicleType(this.currentBodyTypeId, this.currentEngineName);
        this.currentGradeId = gradeId;
        this.setState({
          bodyTypeId: this.currentBodyTypeId,
          engineName: this.currentEngineName,
          vehicleType: this.currentVehicleType,
          gradeId: this.currentGradeId,
        });
      } else if (isExistBodyType) {
        this.changeBodyType(bodyTypeId);
      }

    };

    // URLパラメータでカレント変更
    let carId = BodyControl.getUrlParameter('car_id');
    let gradeId = BodyControl.getUrlParameter('grade');
    if (carId || gradeId) {
      if (carId && gradeId) {
        setCurrent(carId, gradeId);
      } else if (carId) {
        setCurrent(carId);
      }
    } else {

      // ブロックのCookieに保温されている値でカレント変更
      carId = getCookie('mj_gsbt');
      gradeId = getCookie('mj_gsgr');
      if (carId || gradeId) {
        if (carId && gradeId) {
          setCurrent(carId, gradeId);
        } else if (carId) {
          setCurrent(carId);
        }
      } else {

        // 車種サイトのCookieに保温されている値でカレント変更
        carId = getCookie('mjcarid');
        gradeId = getCookie('mjgrade');
        if (carId || gradeId) {
          if (carId && gradeId) {
            setCurrent(carId, gradeId);
          } else if (carId) {
            setCurrent(carId);
          }
        }
      }
    }
    // setCookie('mj_gsbt', 'CarId002');
    // setCookie('mj_gsgr', 'Grade008');

  }

}

export default GradeAndSpec;



// WEBPACK FOOTER //
// ./src/containers/grade-and-spec/index.jsx